import { Grid } from "@mui/material";
import FormInformation from "../../../../../../components/FormInformation/FormInformation";
import { useTranslation } from "react-i18next";
import { useFormContext } from "@4uhub/lib4uhub";
import { TListClassificationForm } from "../listClassificationSchema";

const translationPath = "page.4uDlist.listClassification.";
const FormInformationCode = () => {
  const { getValues } = useFormContext<TListClassificationForm>();
  const code = getValues("code");
  const { t } = useTranslation();
  return (
    <Grid
      item
      xs={12}
      sm={6}
      sx={{ display: "flex", justifyContent: "flex-start" }}
    >
      <FormInformation
        label={t(translationPath + "code") || "Code"}
        data={code?.toString() || ""}
      />
    </Grid>
  );
};

export default FormInformationCode;
